import {
  COMMON_CHUNK_NAME,
  DEFAULT_LINK_AFTER,
  FUNCTION_DEFINE_CHUNK_NAME,
} from '../../../const/generator';

import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IContainerInfo,
} from '../../../types';

export interface PluginConfig {
  fileType: string;
}

const pluginFactory: BuilderComponentPluginFactory<PluginConfig> = (config?) => {
  const cfg: PluginConfig = {
    fileType: FileType.TSX,
    ...config,
  };

  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IContainerInfo;

    if (!ir.statements) {
      return next;
    }

    // 将这些statements 都写入到 组件函数中
    const { state } = ir;
    if (state) {
      try {
        JSON.stringify(state);
      } catch (error) {
        console.error('state 必须是可序列化的对象', error);
        return next;
      }
      next.chunks.push({
        type: ChunkType.STRING,
        fileType: cfg.fileType,
        name: FUNCTION_DEFINE_CHUNK_NAME.InsStatement,
        content: `const [state, setState] = useSetState(${JSON.stringify(state)});`,
        linkAfter: [...DEFAULT_LINK_AFTER[FUNCTION_DEFINE_CHUNK_NAME.Start]],
      });
      next.chunks.push({
        type: ChunkType.STRING,
        fileType: FileType.TSX,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: "import { useSetState } from 'ahooks';",
        linkAfter: [],
      });
    }

    return next;
  };
  return plugin;
};

export default pluginFactory;
